module.exports = __webpack_public_path__ + "img/竞赛-4.643f370c.png";